import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { AlertModal } from 'src/app/app.model';
import { TimesheetService } from 'src/app/services/timesheet.service';
import { roleConstant } from 'src/app/app.constant';
import { AuthenticationService } from 'src/app/services/authentication.service';


@Component({
  selector: 'app-create-admin',
  templateUrl: './create-admin.component.html',
  styleUrls: ['./create-admin.component.css']
})
export class CreateAdminComponent implements OnInit {

  userForm: FormGroup | any;
  name!: string;
  email!: string;
  error!: string;
  user!: any;

  constructor(
    private activeModalService: NgbActiveModal,
    private modalService: NgbModal,
    private timesheetService: TimesheetService,
    private authService: AuthenticationService,) {
    this.user = this.authService.userValue;
  }

  ngOnInit(): void {
    this.userForm = new FormGroup({
      first_name: new FormControl('', Validators.required),
      last_name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  get hasValue() {
    let hasValue = false;
    Object.keys(this.userForm.value).forEach(element => {
      if (this.userForm.value[element]) {
        hasValue = true;
      }
    });
    return hasValue
  }

  onClose() {
    if (!this.hasValue) {
      this.activeModalService.close();
      return
    }
    const modalRef = this.modalService.open(AlertModalComponent, {
      size: 'md',
      modalDialogClass: 'alert-modal modal-dialog-centered',
      backdrop: false,
    });
    let data: AlertModal = {
      message: 'Are you sure you want to discard Admin Creation?',
      yesAction: 'Discard',
      noAction: 'Cancel',
      yesActionColor: '#0566EA',
      noActionColor: 'transparent',
    }
    modalRef.componentInstance.data = data;
    modalRef.result.then((data) => {
      if (data?.action === 'yes') {
        this.activeModalService.close();
      }
    });
  }

  onSubmit() {
    this.error = '';
    const payload = {
      first_name: this.userForm.value.first_name,
      last_name: this.userForm.value.last_name,
      email: this.userForm.value.email,
      role_uuid: roleConstant.AGENCY,
      agency_uuid: this.user.agency_uuid,
    }
    this.timesheetService.createUser(payload).subscribe(res => {
      this.activeModalService.close({ refresh: true });
    }, error => {
      console.error(error);
      this.error = error;
    });
  }

}
